export default __webpack_public_path__ + "img/7da126360729b7bbeae48539be577381.svg";